export default __webpack_public_path__ + "113377e7aa856f99cf9644d0ee87ffaf.png";